import { Roles } from '../constants.js';

export default {
    path: '/admin',
    component: () => import('@/views/layouts/DefaultLayout.vue'),
    meta: { requiresAuth: true, role: Roles.ADMIN },
    children: [
        {
            path: '',
            name: 'AdminDashboard',
            component: () => import('@/views/AdminDashboard.vue'),
        },
        {
            path: 'stripe',
            name: 'StripeDashboard',
            component: () => import('@/views/StripeDashboard.vue'),
        },
    ]
}
